import React from 'react';
import {
  makeStyles, Box, Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginBottom: theme.spacing(1.25),
    textAlign: 'center',
  },
  title: {
    fontWeight: '500',
    textAlign: 'center',
  },
}));

const Spec = (props) => {
  const classes = useStyles();
  const { icon, title, amount } = props;

  return (
    <>
      <Box className={classes.spec}>
        <Box className={classes.icon}>{icon}</Box>

        <Typography variant="h5" className={classes.title}>{amount + title}</Typography>
      </Box>
    </>
  );
};

export default Spec;
